import { Box, CircularProgress, SxProps, Typography } from "@mui/material";

export const Loader = ({
  message = "loading...",
  sx,
  fullWidth = true,
}: {
  message: string;
  fullWidth?: boolean;
  sx?: SxProps;
}) => {
  return (
    <Box
      sx={{
        ...sx,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: fullWidth ? "100%" : "auto",
      }}
    >
      <Box p={2} sx={{ textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="body1" sx={{ marginTop: 2 }}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};
